/* A link drawn as the primary button: a button is not underlined, and the app's link rule would. */
.link {
  text-decoration: none;
}

.link:hover {
  text-decoration: none;
}

/* The sentence that stands where the action would be, for a role that may not take it. */
.reason {
  color: var(--muted);
  font-size: var(--t-dense);
}
